module.exports = __webpack_public_path__ + "media/images/fotos/m13-ico-ee75fd0d88976ec1954624582a5e9187.jpg";